import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons/faPenToSquare';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography/Typography';

interface Props {
  onClickEdit: () => void;
  onClickDelete: () => void;
}

const ActionButton: React.FC<Props> = ({ onClickDelete, onClickEdit }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="btn-group btn-group-sm">
      <button
        type="button"
        className="btn btn-outline-secondary dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        onClick={handleClick}
      >
        操作を選択
      </button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => {
          handleClose();
          onClickEdit();
        }}
        >
          <ListItemIcon><FontAwesomeIcon icon={faPenToSquare} /></ListItemIcon>
          {' '}
          <Typography variant="inherit">編集</Typography>
        </MenuItem>
        <MenuItem onClick={() => {
          handleClose();
          onClickDelete();
        }}
        >
          <ListItemIcon><FontAwesomeIcon icon={faTrash} /></ListItemIcon>
          {' '}
          <Typography variant="inherit">削除</Typography>
        </MenuItem>
      </Menu>

    </div>
  );
};

export default ActionButton;
